import React from "react";

import { Grid } from "@mui/material";
import { SxProps } from "@mui/system";
import { GetProductPickerInfo } from "@src/store/slices/productPicker/types";

import { ProductList } from "./ProductList";
import { SelectAllMessage } from "./SelectAllMessage";

interface ProductSectionProps {
  sx?: SxProps;
  getProductPickerInfo?: GetProductPickerInfo;
  isView?: boolean;
}

export const ProductSection = ({
  sx,
  getProductPickerInfo,
  isView,
}: ProductSectionProps) => {
  return (
    <Grid
      sx={{ height: "100%" }}
      wrap={"nowrap"}
      item
      container
      direction={"column"}
    >
      <Grid item sx={{ paddingX: 4, paddingTop: 4 }}>
        <SelectAllMessage />
      </Grid>
      <Grid justifyContent={"stretch"} item sx={{ height: "100%" }}>
        <ProductList
          getProductPickerInfo={getProductPickerInfo}
          isView={isView}
          showToolTipText={true}
        />
      </Grid>
    </Grid>
  );
};
